import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type { TrackingOriginTypeForNewClientForm } from 'webapp/services/model-manager/spaces';

export default abstract class ClientsBaseController extends Controller {
	@service('model-manager/spaces') declare mmSpacesService: Service.ModelManager.Spaces;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	trackingOrigin = ''; // Defined in every extended controller class

	@cached
	get clients() {
		return this.mmSpacesService.createModelsFromRecordsArray(
			this.mmSpacesService.otherSpaceRecords,
		);
	}

	@action
	createNewClient() {
		if (this.currentUserService.handleDemo()) {
			return;
		}
		this.mmSpacesService.openCreateClientPopup(
			this.trackingOrigin as TrackingOriginTypeForNewClientForm,
		);
	}
}
